const STRIPE_SCRIPT_URL = 'https://js.stripe.com/v3/';

let stripeScriptPromise;

// Loads the Stripe.js SDK on demand instead of unconditionally in index.html.
// Safe to call multiple times - the script is only ever injected once, and
// every caller gets the same promise, resolved with window.Stripe.
export const loadStripeScript = () => {
  if (window.Stripe) {
    return Promise.resolve(window.Stripe);
  }

  if (!stripeScriptPromise) {
    stripeScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = STRIPE_SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve(window.Stripe);
      script.onerror = () => {
        stripeScriptPromise = undefined;
        reject(new Error('Failed to load Stripe.js'));
      };
      document.head.appendChild(script);
    });
  }

  return stripeScriptPromise;
};
